export default __webpack_public_path__ + "static/media/egg_no_shadow.a86c2e85.svg";